module.exports = __webpack_public_path__ + "static/media/oven.1ab6c696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oven.png
// module id = 1061
// module chunks = 0